<div class="school-header" [class.header--thirty-plus]="isPlus30">
  <div class="school-header__container">
    <div class="school-header__title">
      <lx-header-flag [country]="country"></lx-header-flag>
      <div class="school-header__title__school">{{ school }}</div>
      <div class="school-header__title__school-description" *ngIf="schoolDescription">({{ schoolDescription }})</div>
    </div>

    <ng-container *ngIf="customPriceListLinksPresent; else defaultLinks" [ngTemplateOutlet]="customPriceListLinksRef"> </ng-container>
    <ng-template #defaultLinks>
      <lx-price-lists-portal-price-list-links
        *ngIf="!customPriceListLinksPresent"
        [company]="company"
        [countryCode]="country?.code"
        [publicHolidays]="publicHolidays"
        [applicationForms]="applicationForms"
      ></lx-price-lists-portal-price-list-links>
    </ng-template>
  </div>
  <div class="school-header__subtitle" *ngIf="subtitle">
    {{ subtitle }}
  </div>
  <div class="school-header__disclaimer" *ngIf="disclaimer">
    {{ disclaimer }}
  </div>
  <div class="school-header__label-thirty-plus" *ngIf="isPlus30">
    <div class="school-header__label-thirty-plus__title">30+ SCHOOL</div>
    <div class="school-header__label-thirty-plus__description">Specialized classes and social programs</div>
  </div>
</div>
